import nodeAPI from "../../service/ApiServiceNode";

/**
 * Submit feedback (bug report or feature request)
 * Creates a task in the Tech Team queue for HRP Agent to process.
 * @param {FormData} formData - multipart form with text fields + screenshot files
 * @returns {Promise} - { taskId, message }
 */
export const submitFeedback = (formData) =>
    nodeAPI.post("/help-feedback/tickets", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

/**
 * Check a feedback draft for completeness before submitting.
 * Guidance only — the backend accepts thin reports, it just asks for more detail.
 * @param {{title: string, description: string, priority: string}} draft
 * @returns {Promise} - { complete, feedback, suggestedPriority }
 */
export const validateFeedbackDraft = (draft) =>
    nodeAPI.post("/help-feedback/drafts/validate", draft);
